import palette from '../palette';

export default {
  root: {
    backgroundColor: palette.background.default,
  },
  rounded: {
    borderRadius: 8,
  },
  elevation1: {
    boxShadow: '0 1px 3px 0 rgba(0,0,0,0.2)',
  },
};
